import { courtMobile } from '../../utils/texte';
import React, { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { ArrowUpRight, Check, Hourglass, Loader2, LockKeyhole } from 'lucide-react';
import { usePlus360 } from '../../hooks/usePlus360';
import { getApiUrl } from '../../utils/api';
import './plus360.css';

/** Logotype « 360+ » : comme « Sabril. » — Fraunces sur plaque encre, le « + » en orange. */
export const Plus360Mark = ({ size = 28, plate = true, className = '', testId = 'plus360-mark' }) => (
  <span className={`plus-mark ${plate ? 'has-plate' : ''} ${className}`} style={{ '--pm': `${size}px` }} data-testid={testId} aria-label="360+"><span>360</span><i aria-hidden>+</i></span>
);

export const PLUS_PRICE_LABEL = '349 € HT / mois';

/** Bouton de paiement unique : POST /plus-360/checkout → Stripe. Une seule étape (01.3) : l'abonnement principal est inclus. */
export const Plus360Cta = ({ className = '', testId = 'plus360-cta' }) => {
  const { plus, loading } = usePlus360();
  const [busy, setBusy] = useState(false);
  const price = plus?.pricing?.plus_label || PLUS_PRICE_LABEL;
  const checkout = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${getApiUrl()}/plus-360/checkout`, { origin_url: window.location.origin }, { withCredentials: true, timeout: 40000 });
      if (!data.url || new URL(data.url).hostname !== 'checkout.stripe.com') throw new Error('Checkout indisponible');
      if (data.test_mode) toast.info('Mode test : aucun débit réel.');
      window.location.assign(data.url);
    } catch (e) { toast.error(e?.response?.data?.detail || 'Le paiement n’a pas pu être préparé.'); setBusy(false); }
  };
  if (plus?.enabled) return <span className="kit-tag is-mint plus-active-tag" data-testid={`${testId}-active`}><Check size={13} /> 360+ actif</span>;
  if (plus && !plus.can_manage) return <p className="plus-note" data-testid={`${testId}-owner`}>L’activation est réservée au propriétaire de l’établissement.</p>;
  return <button type="button" className={`fh-btn plus-cta ${className}`} onClick={checkout} disabled={busy || loading || (plus && !plus.can_purchase)} data-testid={testId}>{busy ? <Loader2 size={16} className="animate-spin" /> : null}Passer à 360+ · {price}</button>;
};

/** Carte teaser compacte : badge · une ligne · « Débloquer avec 360+ » → page 360+. */
export const Plus360Teaser = ({ moduleKey, line, title, testId = 'plus360-teaser', onNavigate }) => {
  const { plus } = usePlus360();
  const { tenantSlug } = useParams();
  const navigate = useNavigate();
  const mod = plus?.modules?.find((m) => m.key === moduleKey);
  const text = line || mod?.hook || plus?.tagline || 'Tous les modules experts, un seul abonnement.';
  const go = () => { onNavigate?.(); navigate(`/${tenantSlug}/plus-360`); };
  return <article className="plus-teaser hp-card" data-testid={testId}>
    <Plus360Mark size={22} testId={`${testId}-mark`} />
    <div className="plus-teaser-copy">
      {(title || mod?.label) && <p className="plus-teaser-title" data-testid={`${testId}-title`}>{mod?.coming_soon && <Hourglass size={13} />}{!mod?.coming_soon && <LockKeyhole size={13} />}{title || mod.label}</p>}
      <p className="plus-teaser-line" data-testid={`${testId}-line`}>{courtMobile(text, 60)}</p>
    </div>
    <button type="button" className="fh-btn plus-teaser-btn" onClick={go} data-testid={`${testId}-btn`}>Débloquer avec 360+</button>
  </article>;
};
